"use client";
import { Input, InputProps } from "@/components/Input";
import { BuilderBlockProps, CallbackReturnType } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { FC, PropsWithChildren, useEffect, useRef } from "react";
import { useBuilderFormsContext } from "@/hooks";

type GenericTextualInputBlockProps = Extract<
  InputProps,
  {
    type:
      | "date"
      | "datetime-local"
      | "email"
      | "month"
      | "number"
      | "password"
      | "text"
      | "time"
      | "url"
      | "week";
  }
> & {
  onChange?: (event: unknown) => CallbackReturnType;
  onBlur?: (event: unknown) => CallbackReturnType;
  onInvalid?: (event: unknown) => CallbackReturnType;
  onChangeState?: (
    event: unknown,
    correlationId?: string,
  ) => CallbackReturnType;
} & Pick<BuilderProps, "builderContext"> &
  BuilderBlockProps;
export const GenericTextualInputBlock: FC<
  PropsWithChildren<GenericTextualInputBlockProps>
> = ({
  attributes,
  children: _,
  builderContext,
  defaultValue,
  onChangeState,
  ...props
}) => {
  const { correlationId } = useBuilderFormsContext();
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (onChangeState) {
      const onChangeStateWithFormsContext = (event: unknown) => {
        onChangeState(event, correlationId);
      };
      const elem = inputRef.current;
      elem?.addEventListener("changeState", onChangeStateWithFormsContext);

      return () => {
        elem?.removeEventListener("changeState", onChangeStateWithFormsContext);
      };
    }
    // correlationId is stable and we want to ensure the effect runs if onChangeState changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef, onChangeState]);

  return (
    <Input
      {...attributes}
      {...props}
      ref={inputRef}
      value={props.value ?? ""}
    />
  );
};
